import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { useFees } from '@/data/fee';

import FeeRow from './FeeRow';
import NotFound from '@/components/common/NotFound';

const FeeList = () => {
  const fees = useFees();

  if (fees.data?.length === 0) {
    return <NotFound title="No Fees Found" />;
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Label</TableHead>
              <TableHead>Rate</TableHead>
              <TableHead>Type</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {fees.data?.map((fee) => (
              <FeeRow key={fee.id} fee={fee} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {fees.data?.length}
        </span>
      </div>
    </>
  );
};

export default FeeList;
